import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { InputDatepickerNewComponent } from '../../components/input-datepicker-new/input-datepicker-new.component';
import { ItemNotificationComponent } from '../../components/item-notification/item-notification.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import RestService from '../../services/core-rest.service';
import moment from 'moment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import DialogServices from '../../services/dialog.service';
import AppLanguageService from '../../services/app-language.service';
import {ModalSuccessSurveyCreationComponent} from "../modal-success-survey-creation/modal-success-survey-creation.component";
import Session from "../../utils/session.service";
import Config from '../../utils/config.service';

@Component({
	standalone: true,
	selector: 'modal-survey-selection',
	templateUrl: './modal-survey-selection.component.html',
	imports: [
		CommonModule, MatSelectModule, TranslatePipe, LoaderOverlayComponent, 
		InputDatepickerNewComponent, ItemNotificationComponent, FormsModule
	]
})
export class ModalSurveySelectionComponent implements OnInit {
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private restService: RestService = inject(RestService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private appLanguageService: AppLanguageService = inject(AppLanguageService);
	private dialogRef = inject(MatDialogRef<ModalSurveySelectionComponent>);
	private dialogServices: DialogServices = inject(DialogServices);
	private data = inject(MAT_DIALOG_DATA);

	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.getQuestionnaireText = this.getQuestionnaireText;
		this.vm.getLanguagesByOrigin = this.getLanguagesByOrigin;
		this.vm.submit = this.submit;
		this.vm.close = this.close;
		this.vm.preventNativeSubmit = this.preventNativeSubmit;
		this.vm.isComplianceAssessment = this.isComplianceAssessment;
		this.vm.isDateRangeSelected = this.isDateRangeSelected;
		this.vm.isPulseSurvey = this.isPulseSurvey;

		this.initialize();
	}
	
	initialize() {
		this.vm.dateRangeMin = moment(new Date()).toDate();
		this.vm.dateRangeModel = {
		    start: moment(new Date()).toDate(),
		    end: moment().add(1, 'months').toDate()
		};
		this.vm.user = this.session.getSession().user;
		this.vm.languages = this.appLanguageService.getLanguagesByOrigin(this.vm.user.origin);
			this.vm.hideLanguages = this.isComplianceAssessment(this.vm.questionnaireCode);
			this.vm.selectedLanguage = this.getDefaultLanguage();
			if (this.isPulseSurvey() && !this.vm.groupName) {
				this.vm.groupName = 'Pulse - ' + (this.vm.pulseContext && this.vm.pulseContext.pulseRiskName ? this.vm.pulseContext.pulseRiskName : 'Compliance risk');
			}

		this.restService.getSurveySupportsQuestionnaireSearch()
			.then((response) => {
				this.vm.questionnaires = this.filterQuestionnaires(response || []);
				this.vm.initialized = true;
				if(this.vm.questionnaireCode) {
					this.vm.selectedQuestionnaire = this.findQuestionnaireByCodename(this.vm.questionnaireCode);
				}
			})
			.catch((error) => {
				console.log(error);
			});
	}
	
	submit(event?) {
		this.preventNativeSubmit(event);
		this.vm.submitted = true;
		
		if (!this.vm.selectedQuestionnaire || !this.isDateRangeSelected()) return;
		this.vm.processing = true;
		
		var params: any = {
			startDate: moment(this.vm.dateRangeModel.start).format('YYYYMMDD'),
			endDate: moment(this.vm.dateRangeModel.end).format('YYYYMMDD'),
			questionnaireId: this.vm.selectedQuestionnaire.id,
			deselectNotActivated: this.vm.deselectNotActivated, 
			isAllEmployeesSelected: this.vm.isAllEmployeesSelected,
				groupName: this.vm.groupName ? this.vm.groupName : '',
				language: this.vm.selectedLanguage ? this.vm.selectedLanguage.locale : ''
			};
			if (this.isPulseSurvey()) {
				params.pulse = true;
				params.pulseRiskId = this.vm.pulseContext.pulseRiskId || '';
				params.pulseRiskName = this.vm.pulseContext.pulseRiskName || '';
				params.sourceQuestionnaireRequestId = this.vm.pulseContext.sourceQuestionnaireRequestId || '';
			}
		
		this.restService.saveCreateSurvey(params, this.vm.exceptionalEmployeeIds)
			.then((response) => {
				this.vm.processing = false;
				this.dialogRef.close(response || true);
				this.openSuccessModalDialog();
			})
			.catch((error) => {
				console.log(error);
				this.vm.processing = false;
			});
	}

	getLanguagesByOrigin(origin: string) {
		return this.appLanguageService.getLanguagesByOrigin(origin);
	}

	getDefaultLanguage() {
		var userLocale = this.vm.user && this.vm.user.deviceLanguage;
		return (this.vm.languages || []).find((language) => language.locale === userLocale)
			|| (this.vm.languages || [])[0]
			|| this.appLanguageService.getLanguage(userLocale || 'en_GB');
	}

	isDateRangeSelected() {
		return !!(this.vm.dateRangeModel && this.vm.dateRangeModel.start && this.vm.dateRangeModel.end);
	}

	isPulseSurvey() {
		return !!(this.vm.pulseContext && this.vm.pulseContext.pulse === 'true');
	}
	
	getQuestionnaireText(questionnaire) {
	    if (!questionnaire) return this.angularFilterHelperService.translate('Survey_Selection.Survey');
	    if (questionnaire.translation && questionnaire.translation.translationTextName) {
			return questionnaire.translation.translationTextName;
		} else {
			return questionnaire.description;
		}
	}
	
	close() {
		this.dialogRef.close(undefined);
	}

	preventNativeSubmit(event?) {
		if (!event) return;
		event.preventDefault();
		event.stopPropagation();
	}

	findQuestionnaireByCodename(codeName: string): any | null {
		var normalizedCodeName = this.normalizeQuestionnaireCode(codeName);
		return this.vm.questionnaires.find(q => this.normalizeQuestionnaireCode(q && q.codeName) === normalizedCodeName) || null;
	}

	openSuccessModalDialog() {
		this.dialogServices.show({
			controller: ModalSuccessSurveyCreationComponent,
			clickOutsideToClose: false,
			escapeToClose: false,
			multiple: false,
			width: '500px',
			returnPath: this.isComplianceAssessment(this.vm.questionnaireCode) ? '/compliance' : '/employee-surveys',
			returnLabel: this.angularFilterHelperService.translate('Surveys.Back_To_Surveys')
		});
	}

	filterQuestionnaires(questionnaires) {
		var questionnaireCode = this.normalizeQuestionnaireCode(this.vm.questionnaireCode);
		if (!questionnaireCode) return questionnaires;
		return questionnaires.filter((questionnaire) => this.normalizeQuestionnaireCode(questionnaire && questionnaire.codeName) === questionnaireCode);
	}

	isComplianceAssessment(codeName) {
		return this.normalizeQuestionnaireCode(codeName) === 'COMPLIANCE_ASSESSMENT';
	}

	normalizeQuestionnaireCode(value) {
		return (value || '').toString().toUpperCase().replace(/[\s-]+/g, '_');
	}
	
}
